import * as React from "react";
import Input from "../../../../../common/input_text/input_text";
import Title from "../../../../../common/title/title";
import { TrashIcon } from "@heroicons/react/outline";
import { DroneDTO } from "../../../../../store/drone_slice";

interface ExtraGearProps {
  droneData: Partial<Omit<DroneDTO, "id">>;
  updateDroneData: (newData: Partial<Omit<DroneDTO, "id">>) => void;
}

const ExtraGear: React.FC<ExtraGearProps> = ({
  droneData,
  updateDroneData,
}) => {
  const [gearList, setGearList] = React.useState<string[]>(
    droneData.extraGears?.length ? droneData.extraGears : [""]
  );

  React.useEffect(() => {
    // Update the gear list when droneData changes (e.g., when editing)
    if (droneData.extraGears?.length) {
      setGearList(droneData.extraGears);
    }
  }, [droneData.extraGears]);

  const handleGearChange = (index: number, newValue: string) => {
    const newGearList = [...gearList];
    newGearList[index] = newValue;
    setGearList(newGearList);
    
    // Only update the drone data with non-empty values
    const validGears = newGearList.filter(gear => gear.trim());
    if (validGears.length > 0) {
      updateDroneData({ extraGears: validGears });
    }
  };

  const handleAddGear = () => {
    const newGearList = [...gearList, ""];
    setGearList(newGearList);
  };

  const handleDeleteGear = (index: number) => {
    const newGearList = gearList.filter((_, i) => i !== index);
    // Ensure there's always at least one input field
    const finalGearList = newGearList.length ? newGearList : [""];
    setGearList(finalGearList);
    
    // Only update the drone data with non-empty values
    const validGears = finalGearList.filter(gear => gear.trim());
    updateDroneData({ extraGears: validGears });
  };

  return (
    <div className="max-w-2xl mx-auto mt-8">
      <Title
        title="Extra Gear"
        subtitle="Make your offer stand out by giving something more"
      />
      {gearList.map((gear, index) => (
        <div key={index} className="flex items-center space-x-4 mb-4">
          <div className="w-full">
            <Input
              value={gear}
              onChange={(value) => handleGearChange(index, value)}
              placeholder="Enter gear description"
              variant="specs"
            />
          </div>
          <button
            onClick={() => handleDeleteGear(index)}
            className="text-red-500 hover:text-red-700"
            type="button"
          >
            <TrashIcon className="w-6 h-6" />
          </button>
        </div>
      ))}
      <button
        onClick={handleAddGear}
        className="font-ubuntu flex items-center justify-center px-4 py-2 border border-gray-300 rounded-lg text-primary hover:bg-gray-100 w-1/3"
        type="button"
      >
        + Add
      </button>
    </div>
  );
};

export default ExtraGear;
